import React from 'react';
import {AdminPanelSettings, Security} from '@mui/icons-material';
import {Button} from '@mui/material';
import List from 'components/list/List';
import {CheckField, ListField} from 'components/list/Fields';
import CreateButton from 'components/forms/CreateButton';
import ActionMenu from 'components/list/actionMenu/ActionMenu';
import ActionMenuItemEdit from 'components/list/actionMenu/ActionMenuItemEdit';
import ActionMenuItemDelete from 'components/list/actionMenu/ActionMenuItemDelete';
import ActionMenuItemConfirmDialog from 'components/list/actionMenu/ActionMenuItemConfirmDialog';
import {useRecordContext} from 'components/record/useRecordContext';
import RoleForm from './RoleForm';
import RolePermissionsForm, {ROLE_PERMISSIONS_FORM_ID} from './RolePermissionsForm';
import {ActionMenuItemProps} from 'components/list/actionMenu/ActionMenuItem';

const RoleActionMenuItemEdit = (props: React.ComponentProps<typeof ActionMenuItemEdit>) => {
  const {record} = useRecordContext();

  if (record.isSystem) {
    return null;
  }

  return <ActionMenuItemEdit {...props} />;
};

const RoleActionMenuItemDelete = (props: React.ComponentProps<typeof ActionMenuItemDelete>) => {
  const {record} = useRecordContext();

  if (record.isSystem) {
    return null;
  }

  return <ActionMenuItemDelete {...props} />;
};

const RoleActionMenuItemPermissions = ({onSuccess, ...props}: ActionMenuItemProps) => {
  const {record} = useRecordContext();
  const isPermissionsEditable = !!record.isPermissionsEditable;

  return (
    <ActionMenuItemConfirmDialog
      label="Permissions"
      icon={<Security />}
      confirmTitle={`Permissions for ${record.name}`}
      confirmContent={<RolePermissionsForm onSuccess={onSuccess} readOnly={!isPermissionsEditable} />}
      primaryButton={
        isPermissionsEditable ? (
          <Button type="submit" form={ROLE_PERMISSIONS_FORM_ID} variant="contained">
            Save
          </Button>
        ) : undefined
      }
      {...props}
    />
  );
};

const RolesPage = () => {
  return (
    <List
      hidePagination
      title="Roles"
      avatar={<AdminPanelSettings />}
      toolbar={
        <CreateButton>
          <RoleForm />
        </CreateButton>
      }
    >
      <ListField source="name" label="Name" />
      <CheckField source="isSystem" label="System" />
      <ActionMenu label="Actions" align="right" width="5%">
        <RoleActionMenuItemEdit confirmContent={<RoleForm />} />
        <RoleActionMenuItemPermissions />
        <RoleActionMenuItemDelete />
      </ActionMenu>
    </List>
  );
};

export default RolesPage;
